import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/redux/reducers";
import { setOutsideClickWarningModalVisibility } from "src/redux";
import IDHFormattedMessage from "../IDHFormattedMessage/IDHFormattedMessage";
import { WarningModal } from "src/app/modals/WarningModal/WarningModal";
import layerManager from "src/utils/layerManager";

import "./OutsideClickWarningModal.scss";

const OutsideClickWarningModal = () => {
  const { outsideClickWarningModalVisible } = useSelector(
    (state: RootState) => state.globalModalsReducer,
  );

  const dispatch = useDispatch();

  if (!outsideClickWarningModalVisible) return null;

  const handleClose = () => {
    dispatch(setOutsideClickWarningModalVisibility(false));
  };

  const confirmFunction = () => {
    handleClose();
    setTimeout(() => {
      layerManager.handleEscape();
    }, 0);
  };

  return (
    <WarningModal
      onClose={handleClose}
      confirmAction={confirmFunction}
      upperText={
        <IDHFormattedMessage
          id="ws_outside_click_warning_modal_text"
          defaultMessage="Unsaved data could be lost"
        />
      }
      warningMessage={
        <IDHFormattedMessage
          id="ws_outside_click_warning_modal_warning"
          defaultMessage="Make sure you don't lose any data."
        />
      }
    />
  );
};

export default OutsideClickWarningModal;
